/*global Stretchy*/
import { anchorFooter } from '../common';
import 'jquery-deserialize';
import serialize from 'form-serialize';

var $form = $(".section__search")
  , $table = $(".table")
  , $tbody = $table.find("tbody")
  , $theaders = $table.find('th')
  , $topicsOverview = $('.topics-overview')
  , $topicsSearch = $('.topics-search')
  , $topicsResults = $('.topic-full__list')
  , $resetButton = $('.section__search__reset')
  , $pagination = $('.pagination');

var isTopicsCollection = ($topicsOverview.length > 0);

function deserializeQuerystring() {
  var serializedArray = location.search.replace(/^\?/,'').split('&');
  var obj = {};

  if (serializedArray === "")
    return {};

  for (var i = 0; i < serializedArray.length; i += 1) {
    var param = serializedArray[i].split('=');
    if (param.length === 2) {
      var key = decodeURIComponent(param[0]);
      var value = decodeURIComponent(param[1].replace(/\+/g, " "));
      if(key.indexOf('[]') > -1){
      // This is an array of values
      key = key.replace('[]', '');

        if(obj[key]){
          obj[key].push(value);
        } else {
          obj[key] = [value];
        }
      } else {
        obj[decodeURIComponent(param[0])] = value;
      }
    }
  }

  return obj;
}

function slugify(str) {
  return str.replace(/[^a-zA-Z0-9]+/ig, '-').replace(/^-|-$/ig, '').toLowerCase();
}

function getValues() {
  return $form.find(':input').filter(function() {
    return !!$(this).val() && $(this).val() != $(this).attr('data-default');
  }).serialize().replace(/%5B%5D/g, '[]');
}

function updateHistoryState(){
  var values = getValues();
  history.pushState({'popstate': true}, '', ((values) ? '?'+values : location.pathname));
}

function showLoadingState() {
  if(isTopicsCollection){
    $topicsOverview.addClass('is-hidden');
    $topicsSearch.removeClass('is-hidden');
    $topicsSearch.addClass('is-loading');
  } else {
    $table.addClass('is-loading');
  }
}

function hideLoadingState() {
  if(isTopicsCollection){
    if(!getValues()){
      hideTopicsSearch();
    } else {
      $topicsSearch.removeClass('is-loading');
    }
  } else {
    $table.removeClass('is-loading');
  }
}

function hideTopicsSearch(){
  $topicsOverview.removeClass('is-hidden');
  $topicsSearch.addClass('is-hidden');
}

function search(sortByRelevance) {
  updateSort(sortByRelevance);
  populateFormFromQuerystring();
  resetPageParam();

  var formData = serialize($form.get(0), { hash: true });
  var querystring_params = deserializeQuerystring();
  var collection = $form.data('collection');
  var filters = (collection && collection !== '') ? { 'collection': collection } : {};

  checkBoxesFromParams(querystring_params);

  formData.engine_key = $form.data('engineKey');
  formData.per_page = formData.page_size;
  formData.page = querystring_params.page;

  if(sortByRelevance){
    formData.sort_field = null;
    formData.sort_direction = null;
  } else {
    formData.sort_field = { 'page': formData.sort_field };
    formData.sort_direction = { 'page': formData.sort_direction };
  }

  filters = getFiltersFromSelect(filters);
  filters = getFiltersFromCheckboxes(filters);

  filters['site_domain'] = $form.data('domain');
  filters['org_type'] = formData.org_type;
  filters['type'] = formData.type;
  if (formData.pre_filter == "subject_specialties" && !filters['subject_specialties']){
    filters[formData.pre_filter] = 'all';
  }
  formData.filters = { 'page': filters };

  showLoadingState();
  $resetButton.toggleClass('is-hidden', !getValues());

  if(collection === "people"){
    if((formData.subject_specialties && formData.subject_specialties.value !== "") || formData.pre_filter == "subject_specialties"){
      $table.addClass("showing-subject_specialties");
    } else {
      $table.removeClass("showing-subject_specialties");
    }
  }

  // specify fields to be searched by swiftype
  formData.search_fields = {
    'page': [
        'departments',
        'card_html',
        'body',
        'address',
        'title',
        'sections',
        'info',
        'phone',
        'email',
        'twitter',
        'facebook',
        'parent_department',
        'departments',
        'location',
        'space',
        'status',
        'liaison_relationship',
        'topics',
        'access',
        'amenities',
        'keywords',
        'country',
        'noise_level',
        'org_type',
        'is_reservable',
        'is_graduate_only',
        'technology'
      ]
  };
  $.ajax({
    url: "https://api.swiftype.com/api/v1/public/engines/search.json",
    data: JSON.stringify(formData),
    processData: false,
    contentType: 'application/json',
    dataType: "json",
    method: "POST",
    success: renderResults
  })
  .fail(function(){
    renderMessage('Could not load results. <a href="">Try again?</a>');
  })
  .always(hideLoadingState);
}

function renderResults(data) {
  if(isTopicsCollection) {
    $topicsResults.html('');
  } else {
    $tbody.html('');
  }

  $.each(data.records, function (documentType, items) {
    if (items.length > 0) {
      var $frag = $(document.createDocumentFragment());

      $.each(items, function (idx, item) {
        var $renderedResult = isTopicsCollection ? renderTopicResult(item) : renderTableRow(item);
        $renderedResult.appendTo($frag);
      });

      $frag.appendTo(isTopicsCollection ? $topicsResults : $tbody);
    } else {
      renderMessage('No results found. <a href="?">Reset filters?</a>');
    }
  });

  renderPagination(data.info);
  anchorFooter();
}

function renderTopicResult(item) {
  return $('<li class="topic__li"><a href="' + item.url + '">' + item.title + '</a></li>');
}

function renderTableRow(item) {
  var tr = $('<tr class="table__row">');
  $theaders.each(function() {
    var field = $(this).data('field');
    var td = $('<td class="table__cell table__cell--'+ field +'">').append(renderTableCol(item, field));
    tr.append(td);
  });
  return tr;
}

function renderTableCol(item, key) {
  key = key === 'subject_specialties' ? 'subject_sub_specialties' : key;
  const value = item[key];
  const values = typeof value === 'string' ? [value] : value;
  const { card_html, parent_department } = item;
  const collection = $form.data('collection');
  const hasKey = arr => arr.includes(key);

  if (!value) {
    return "";
 } else if (hasKey(['title', 'sort_title']) && card_html) {
    return card_html;
  } else if (key === 'departments') {
    return $.map(values, dept => $(`<a href="/${key}/${slugify(parent_department || dept)}">${dept}</a>`)[0].outerHTML).join('<span class="breadcrumb-separator"> &gt; </span>');
  } else if (key === 'location' && collection === 'classrooms') {
    return $(`<a href="/services/campus-media/classrooms/?location=${value.split(' ').join('+')}">${value}</a>`);
  } else if (hasKey(['service', 'space', 'location'])) {
    return $(`<a href="/${key}s/${slugify(value)}">${value}</a>`);
  }

  return values.join('<br/>') || "";
}

function renderMessage(message) {
  if(isTopicsCollection){
    $topicsResults.html('<li>' + message + '</li>');
  } else {
    $tbody.html(renderTableMessage(message));
  }
}

function renderTableMessage(message) {
  return '<tr class="table__row empty"><td class="table__cell" colspan="'+$theaders.length+'">'+message+'</td></tr>';
}

function renderPagination(resultInfo) {
  var maxPagesType, maxPages = -1;
  $.each(resultInfo, function(documentType, typeInfo) {
    if (typeInfo.num_pages > maxPages) {
      maxPagesType = documentType;
      maxPages = typeInfo.num_pages;
    }
  });
  var currentPage = resultInfo[maxPagesType].current_page,
    totalPages = resultInfo[maxPagesType].num_pages;

  $pagination.html('');

  if (totalPages > 1) {

    var startPage = Math.max(1, (currentPage - 2));
    var trailingPages = Math.max(2, (5 - currentPage));
    var endPage = Math.min(totalPages, (currentPage + trailingPages));
    var ellipsisHTML = "<span class='pagination__link'>&hellip;</span>";

    if(startPage !== 1)
      $pagination.append('<a href="?page=1" class="pagination__prev ss-left" data-page="1">First</a>');

    if (currentPage > 1) {
      var i = currentPage - 1;
      $pagination.append('<a href="?page='+i+'" class="pagination__prev ss-icon" data-page="'+i+'" title="Previous page">left</a>');
    }

    if(startPage !== 1)
      $pagination.append(ellipsisHTML);

    for (i=startPage; i <= endPage; i++) {
      $pagination.append($('<a href="?page='+i+'" class="pagination__link" data-page="'+i+'">'+i+'</a>').toggleClass('is-selected', (currentPage == i)));
    }

    if(endPage !== totalPages)
      $pagination.append(ellipsisHTML);

    if (currentPage < totalPages) {
      i = currentPage + 1;
      $pagination.append('<a href="?page='+i+'" class="pagination__next ss-icon" data-page="'+i+'" title="Next page">right</a>');
    }

    if(endPage !== totalPages)
      $pagination.append('<a href="?page='+totalPages+'" class="pagination__next ss-right right" data-page="'+totalPages+'">Last</a>');

  }
}

function updateSort(sortByRelevance) {
  $theaders.removeAttr('data-sort');
  $theaders.removeAttr('aria-sort');

  if(!sortByRelevance){
    var sortField = $form.find('input[name=sort_field]').val();
    var sortDirection = $form.find('input[name=sort_direction]').val();
    $theaders.filter('[data-field='+sortField+']').attr({'data-sort':sortDirection, 'aria-sort':ariaDirection(sortDirection)});
  }
}

function ariaDirection(sortDirection) {
  return sortDirection == "asc" ? "ascending" : "descending"
}

function populateFormFromQuerystring() {
  var params = deserializeQuerystring();

  $form.find('input[name=q]').val(params['q']);

  $form.find('select').each(function() {
    $(this).find('option[value="'+decodeURIComponent(params[$(this).attr('name')])+'"]').prop('selected', true);
  });

  Object.keys(params).forEach((key) => {
    if(Array.isArray(params[key])){
      var param = params[key];
      for (var y = param.length - 1; y >= 0; y--) {
        var val = decodeURIComponent(param[y]);
        $form.find('input[name="' + key + '[]"][value="' + val + '"]').prop('checked', true);
      }
    }
  });
}

function resetPageParam() {
  $form.find('input[name=page]').val(1);
}

function checkBoxesFromParams(querystring_params) {
  $form.find(':checkbox').each(function() {
    if(!$(this).is(':checked')){
      $(this).prop('checked', ($(this).attr('name') in querystring_params));
    }
  });
}

function getFiltersFromSelect(filters){
  $form.find('select').each(function() {
    if ($(this).val()) {
      filters[$(this).attr('name')] = $(this).val();
    }
  });
  return filters;
}

function getFiltersFromCheckboxes(filters){
  $form.find(':checkbox').each(function() {
    if ($(this).is(':checked')) {
      filters[$(this).attr('name')] = $(this).val();
    }
  });
  return filters;
}

$(function() {
  $form.on('submit', function(e) {
    e.preventDefault();
    updateHistoryState();
    // only sort by relevance if there is a search query
    if ($form.find('input[name=q]').val()) {
      search(true);
    } else {
      search();
    }
  });

  $form.find(':input').on('change', function() {
    if(!this.classList.contains('section__search__field')){
      var $this = $(this);
      var $locationFilter = $this.closest('.filter--location');

      // Check hidden "type" filters on Locations page
      if($locationFilter.length){
        var checked = $this.prop('checked');
        $locationFilter.find('input.is-hidden').prop('checked', checked);
      }

      resetPageParam();
      $form.trigger('submit');
    }
  });

  $table.find('.table__cell--sortable').on('click keydown', function(e) {
    if (e.keyCode === undefined || e.keyCode === 32 || e.keyCode === 13) {
      e.preventDefault();
      var direction = ($(this).attr('data-sort') == 'asc') ? 'desc' : 'asc';
      $form.find('input[name=page]').val(1);
      $form.find('input[name=sort_field]').val($(this).attr('data-field'));
      $form.find('input[name=sort_direction]').val(direction);
      updateHistoryState();
      search();
    }
  });

  $resetButton.on('click', function(e) {
    e.preventDefault();
    location.search = '';
    $form.trigger('reset');
    updateHistoryState();
    search();

    if (Stretchy) {
      Stretchy.resizeAll();
    }
  });

  $('.subfilters__toggle').on('click', function() {
    var container = document.querySelector('.subfilters__container');
    var subfilters = container.querySelectorAll('.filter');
    var button = this;
    var visible = container.classList.contains('is-hidden');
    container.classList.toggle('is-hidden');

    if(visible){
      button.setAttribute('data-original', button.innerHTML);
      button.classList.remove('ss-plus');
      button.classList.add('ss-navigateup');
      button.innerHTML = "Less filters";

      if (Stretchy) {
        Stretchy.resizeAll(subfilters);
      }

    } else {
      button.classList.add('ss-plus');
      button.classList.remove('ss-navigateup');
      button.innerHTML = button.getAttribute('data-original');
    }
  });

  $pagination.on('click', 'a', function(e) {
    e.preventDefault();
    $form.find('input[name=page]').val($(this).attr('data-page'));
    updateHistoryState();
    search();

    $('html, body').animate({
      scrollTop: $table.offset().top
    }, 500);
  });

  // check on page load
  if (location.search.length > 1) {
    var querystring_params = deserializeQuerystring();
    // only sort by relevance if there is a search query
    if (querystring_params.q) {
      search(true);
    } else {
      search();
    }
  }

});
